import React, { useState, useEffect, useCallback } from 'react';
import API from '../api';
import { UserPlus, KeyRound, Ban, CheckCircle2 } from 'lucide-react';

const inputStyle = {
  width: '100%', padding: '8px 10px', border: '1px solid #d6d3d1',
  borderRadius: 6, fontSize: 13, boxSizing: 'border-box'
};
const labelStyle = { fontSize: 12, fontWeight: 600, color: '#44403c', display: 'block', marginTop: 10 };

export default function Utenti() {
  const [utenti, setUtenti] = useState([]);
  const [ruoli, setRuoli] = useState([]);
  const [mostraNuovo, setMostraNuovo] = useState(false);
  const [messaggio, setMessaggio] = useState(null);
  const [form, setForm] = useState({
    username: '', password: '', nome: '', cognome: '', ruolo_id: '', avvocato_id: ''
  });

  const carica = useCallback(() => {
    API.get('/utenti').then(r => setUtenti(r.data)).catch(() => {});
    API.get('/ruoli').then(r => setRuoli(r.data)).catch(() => {});
  }, []);

  useEffect(() => { carica(); }, [carica]);

  const notifica = (testo, errore = false) => {
    setMessaggio({ testo, errore });
    setTimeout(() => setMessaggio(null), 4000);
  };

  const creaUtente = async () => {
    if (!form.username || !form.password || !form.ruolo_id) {
      notifica('Username, password e ruolo sono obbligatori', true);
      return;
    }
    try {
      await API.post('/utenti', {
        ...form,
        ruolo_id: parseInt(form.ruolo_id),
        avvocato_id: form.avvocato_id ? parseInt(form.avvocato_id) : null,
      });
      notifica('Utente creato');
      setForm({ username: '', password: '', nome: '', cognome: '', ruolo_id: '', avvocato_id: '' });
      setMostraNuovo(false);
      carica();
    } catch (e) {
      notifica(e.response?.data?.detail || 'Errore nella creazione', true);
    }
  };

  const toggleAttivo = async (u) => {
    try {
      await API.patch(`/utenti/${u.id}`, { attivo: !u.attivo });
      notifica(u.attivo ? `${u.username} disattivato` : `${u.username} riattivato`);
      carica();
    } catch (e) {
      notifica(e.response?.data?.detail || 'Errore', true);
    }
  };

  const resetPassword = async (u) => {
    const nuova = window.prompt(`Nuova password per ${u.username} (min. 8 caratteri):`);
    if (!nuova) return;
    try {
      await API.patch(`/utenti/${u.id}`, { password: nuova });
      notifica(`Password di ${u.username} aggiornata`);
    } catch (e) {
      notifica(e.response?.data?.detail || 'Errore', true);
    }
  };

  const cambiaRuolo = async (u, nuovoRuoloId) => {
    try {
      await API.patch(`/utenti/${u.id}`, { ruolo_id: parseInt(nuovoRuoloId) });
      notifica(`Ruolo di ${u.username} aggiornato`);
      carica();
    } catch (e) {
      notifica(e.response?.data?.detail || 'Errore', true);
    }
  };

  return (
    <div style={{ padding: 24, maxWidth: 1000 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <h2 style={{ margin: 0 }}>Gestione utenti</h2>
        <button onClick={() => setMostraNuovo(!mostraNuovo)}
          style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '9px 16px',
                   background: '#1c1917', color: 'white', border: 'none', borderRadius: 8,
                   fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>
          <UserPlus size={16} /> Nuovo utente
        </button>
      </div>

      {messaggio && (
        <div style={{
          padding: '10px 14px', borderRadius: 8, marginBottom: 16, fontSize: 13,
          background: messaggio.errore ? '#FEF2F2' : '#F0FDF4',
          border: `1px solid ${messaggio.errore ? '#FECACA' : '#BBF7D0'}`,
          color: messaggio.errore ? '#B91C1C' : '#166534'
        }}>
          {messaggio.testo}
        </div>
      )}

      {mostraNuovo && (
        <div style={{ background: 'white', border: '1px solid #e7e5e4', borderRadius: 10,
                      padding: 20, marginBottom: 20 }}>
          <div style={{ fontWeight: 700, marginBottom: 4 }}>Nuovo utente</div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0 16px' }}>
            <div>
              <label style={labelStyle}>Username *</label>
              <input style={inputStyle} value={form.username}
                onChange={e => setForm({ ...form, username: e.target.value })} />
            </div>
            <div>
              <label style={labelStyle}>Password * (min. 8)</label>
              <input style={inputStyle} type="password" value={form.password}
                onChange={e => setForm({ ...form, password: e.target.value })} />
            </div>
            <div>
              <label style={labelStyle}>Nome</label>
              <input style={inputStyle} value={form.nome}
                onChange={e => setForm({ ...form, nome: e.target.value })} />
            </div>
            <div>
              <label style={labelStyle}>Cognome</label>
              <input style={inputStyle} value={form.cognome}
                onChange={e => setForm({ ...form, cognome: e.target.value })} />
            </div>
            <div>
              <label style={labelStyle}>Ruolo *</label>
              <select style={inputStyle} value={form.ruolo_id}
                onChange={e => setForm({ ...form, ruolo_id: e.target.value })}>
                <option value="">— seleziona —</option>
                {ruoli.map(r => <option key={r.id} value={r.id}>{r.nome} — {r.descrizione}</option>)}
              </select>
            </div>
          </div>
          <button onClick={creaUtente}
            style={{ marginTop: 16, padding: '9px 20px', background: '#1c1917', color: 'white',
                     border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>
            Crea utente
          </button>
        </div>
      )}

      <div style={{ background: 'white', border: '1px solid #e7e5e4', borderRadius: 10, overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
          <thead>
            <tr style={{ background: '#fafaf9', textAlign: 'left' }}>
              <th style={{ padding: '10px 14px' }}>Utente</th>
              <th style={{ padding: '10px 14px' }}>Ruolo</th>
              <th style={{ padding: '10px 14px' }}>Ultimo accesso</th>
              <th style={{ padding: '10px 14px' }}>Stato</th>
              <th style={{ padding: '10px 14px' }}>Azioni</th>
            </tr>
          </thead>
          <tbody>
            {utenti.map(u => (
              <tr key={u.id} style={{ borderTop: '1px solid #f5f5f4', opacity: u.attivo ? 1 : 0.5 }}>
                <td style={{ padding: '10px 14px' }}>
                  <div style={{ fontWeight: 600 }}>{u.nome} {u.cognome}</div>
                  <div style={{ color: '#78716c', fontSize: 12 }}>@{u.username}</div>
                </td>
                <td style={{ padding: '10px 14px' }}>
                  <select value={u.ruolo_id} onChange={e => cambiaRuolo(u, e.target.value)}
                    style={{ ...inputStyle, width: 'auto', padding: '5px 8px' }}>
                    {ruoli.map(r => <option key={r.id} value={r.id}>{r.nome}</option>)}
                  </select>
                </td>
                <td style={{ padding: '10px 14px', color: '#78716c' }}>
                  {u.ultimo_accesso ? new Date(u.ultimo_accesso).toLocaleString('it-IT') : 'mai'}
                </td>
                <td style={{ padding: '10px 14px' }}>
                  <span style={{
                    padding: '3px 10px', borderRadius: 20, fontSize: 12, fontWeight: 600,
                    background: u.attivo ? '#F0FDF4' : '#FEF2F2',
                    color: u.attivo ? '#166534' : '#B91C1C'
                  }}>
                    {u.attivo ? 'Attivo' : 'Disattivato'}
                  </span>
                </td>
                <td style={{ padding: '10px 14px' }}>
                  <button onClick={() => resetPassword(u)} title="Reimposta password"
                    style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 6, color: '#57534e' }}>
                    <KeyRound size={16} />
                  </button>
                  <button onClick={() => toggleAttivo(u)} title={u.attivo ? 'Disattiva' : 'Riattiva'}
                    style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 6,
                             color: u.attivo ? '#B91C1C' : '#166534' }}>
                    {u.attivo ? <Ban size={16} /> : <CheckCircle2 size={16} />}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
